import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { AuthService, IEmailCodeResult } from '../../services/auth.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController, NavParams } from '@ionic/angular';
import { Router } from '@angular/router';
import { StoreListModalComponent } from 'src/app/store/modals/store-list-modal/store-list-modal.component';
import { ReservationComponent } from 'src/app/reservation-page/pages/reservation-page/reservation-page.component';
import { OrderListPageComponent } from 'src/app/account/pages/order-list-page/order-list-page.component';
import { LocationsPageComponent } from 'src/app/pages/locations-page/locations-page.component';
import { PayRewardPageComponent } from 'src/app/account/pages/pay-reward-page/pay-reward-page.component';
import { ProfilePageComponent } from 'src/app/account/pages/profile-page/profile-page.component';
import { SupportHomePageComponent } from 'src/app/support/pages/support-home-page/support-home-page.component';
import { OfferPageComponent } from 'src/app/account/pages/offer-page/offer-page.component';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from 'src/app/shared/services/alert.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { IRegisterForm } from '../../forms/register-form/register-form.component';
import { HttpHelpers } from 'src/app/shared/helpers/http.helpers';
import { AccountService } from 'src/app/account/services/account.service';

@Component({
  selector: 'app-all-in-one-auth-page',
  templateUrl: './all-in-one-auth-page.component.html',
  styleUrls: ['./all-in-one-auth-page.component.scss'],
  standalone: false
})
export class AllInOneAuthPageComponent  implements OnInit {

  email: string = '';
  emailReset: string = '';
  emailRegister: string = '';
  password: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  resetCode: string;

  
  //registration specific variables:
  acceptEmails: boolean = true;
  registrationPassword: string;
  confirmRegistrationPassword: string;
  firstName: string;
  lastName: string;
  randomCode: string; // aka the code sent by email
  memberCard: string; // this is optional in the registration
  cvc: number; // this is optional in the registration


  codeSentAttempt: number = 0;
  registrationCodeSentAttempt: number = 0;

  viewpassword: boolean = false;
  viewpasswordNew: boolean = false;
  viewpasswordConfirm: boolean = false;
  viewpasswordNewRegistration: boolean = false;
  viewpasswordConfirmRegistration: boolean = false;
  

  rememberMe: boolean = false;

  @Input() selfManage: boolean = false;
  @Input() fromDesktopCheckout: boolean = false;
  @Input() directRegistration: boolean = false;

  loginTab: boolean = true;
  registrationTab: boolean = false;
  paswwordResetTab: boolean = false;

  emailCodePassReset: IEmailCodeResult;
  emailCodeRegistration: IRegisterForm;

  registrationStep: string = "email";
  alreadyInUse: boolean = false;

  title: string = 'Nav.Login';
  mobile: boolean = false;
  @Input() disableHeader = false;
  @Input() isPopup = false;

  @Output() onLoginAllinOne: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() notLoginAllinOne: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() continueAsGuest: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() unchangeUrl: boolean = false;
  @Input() guestOption: boolean = false;
  
  

  constructor(
    private loader: LoaderService, 
    private router: Router, 
    private authService: AuthService, 
    public setting: SettingService, 
    private analytics: AnalyticsService,
    private modalCtrl: ModalController,
    private sanitizer: DomSanitizer,
    private alertService: AlertService,
    private translationService: TranslationService,
    private account: AccountService
  ) { }

  ngOnInit() {

    if(this.directRegistration) {
      this.gotoAccountRegistration();
    }

    if(this.isPopup) {
      if (window.innerWidth <= 600) {
        this.mobile = true;
  
        //this.disableHeader = false;
      } else {
        this.mobile = false;
  
        //this.disableHeader = true;
      }
    }

    // temporarily. we'll need to set it up on the page soon
    (window as any).updateLoaderProgress(100);
    (window as any).finishAppShell?.();
  }

  togglePasswordView(type) {
    if(type == 'login') {
      this.viewpassword = !this.viewpassword;
    } else if(type == 'ResetPassNew') {
      this.viewpasswordNew = !this.viewpasswordNew;
    } else if(type == 'ConfirmPass') {
      this.viewpasswordConfirm = !this.viewpasswordConfirm;
    } else if(type == 'ResetPassNewReg') {
      this.viewpasswordNewRegistration = !this.viewpasswordNewRegistration;
    } else if(type == 'ConfirmPassReg') {
      this.viewpasswordConfirmRegistration = !this.viewpasswordConfirmRegistration;
    }
  }

  ContinueAsGuest() {
    this.continueAsGuest.emit(true);
  }

  submitLogin() {
    this.onFormSubmited();
  }

  gotologin() {
    this.loginTab = true;
    this.registrationTab = false;
    this.paswwordResetTab = false;

    this.registrationStep = 'email';
  }

  gotoforgottenPassword() {
    this.loginTab = false;
    this.registrationTab = false;
    this.paswwordResetTab = true;

    if(!this.emailReset && this.email) {
      this.emailReset = this.email;
    }

    this.registrationStep = 'email';
  }

  gotoAccountRegistration() {
    this.loginTab = false;
    this.registrationTab = true;
    this.paswwordResetTab = false;

    if(!this.emailRegister && this.email) {
      this.emailRegister = this.email;
    }

    this.registrationStep = 'email';
  }

  startRegistration() {
    console.log("registration start");
    if(this.setting.configuration.memberCardMandatory) {
      this.registrationStep == 'memberCard';
    } else {
      this.registrationCodeSentAttempt = 1;
      this.onRegistrationCodeFormSubmit();
    }
  }

  memberCardRegistration() {
    console.log("registration start post-member card");

    this.onConfirmMemberCardFormSubmit();
  }

  RegistrationProcess() {
    console.log("send registration data");
    this.onRegisterAccountFormSubmit();
  }

  sendResetCode() {
    console.log("reset password");
    this.codeSentAttempt = 1;
    this.onResetCodeFormSubmit()
  }

  changePassword() {
    console.log("change password");
    this.onChangePasswordForgotFormSubmited()
  }


  passwordsMatch(type) {
    if(type == "ResetPass") {
      return this.newPassword === this.confirmPassword;
    } else if(type == "Registration") {
      return this.registrationPassword === this.confirmRegistrationPassword;
    }
    
  }

  async onConfirmMemberCardFormSubmit() {
    //this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    /*
    if (!this.form.valid)
      return;
    */

    //this.formErrors.clear();

    const loader = await this.loader.create();
    await loader.present();

    this.account.confirmMemberCard(this.memberCard, this.cvc)
      .subscribe(async (result: boolean) => {
        
        loader.dismiss();


        if(result) {
          this.registrationCodeSentAttempt = 1;
          this.onRegistrationCodeFormSubmit();
        } else {
          this.alertService.showTranslate('the member card information provided invalid');
        }
        

        /*
        if(result) {
          //this.onSubmit.emit(this.form.get("memberCard").value);

          //this.modalCtrl.dismiss(this.form.get("memberCard").value);
        } else {
          this.ResponseFalse = true;
          setTimeout(() => {
            this.ResponseFalse = false;
          }, 3500); 
        }
        */
      });
  }


  async onRegistrationCodeFormSubmit() {
    //sanitizing
    //this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    this.alreadyInUse = false;

    /*
    if (!this.form.valid)
      return;
    */

    //this.formErrors.clear();


    // do the member card modal after

    // put the logic for the member card here before we send the code
    /*
    if(this.settingService.configuration.memberCardMandatory) {
      this.OpenMemberCardModal();

    } else {
      */

      const loader = await this.loader.create();
      await loader.present();
      this.authService.emailCodeVerificationStart(this.emailRegister, "Register", this.translationService.getLanguage())
        .pipe(finalize(() => {
          loader.dismiss();
        }))
        .subscribe(result => {
          this.emailCodeRegistration = {
            email: this.emailRegister,
            codeId: result.EmailCodeId,
            codeExpirationTime: result.ExpirationTime,
            memberCard: this.memberCard,
            cvc: this.cvc
          };

          this.registrationStep = 'registration';

          this.registrationCodeSentAttempt++;

          this.alertService.showTranslate('A code has been sent to your email');
        },
        (error: HttpErrorResponse) => {
          if (error.error.Message == 'AlreadyExist')
            this.alreadyInUse = true;
            this.alertService.showTranslate('this email is already in use');
        });
    //}


    
  }

  async onRegisterAccountFormSubmit() {
    //sanitizing
    //this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    /*
    if (!this.form.valid)
      return;
    */

    //this.formErrors.clear();

    const loader = await this.loader.create();
    await loader.present();

    this.authService.register({
      AcceptEmails: this.acceptEmails,
      Id: this.emailCodeRegistration.codeId,
      Password: this.registrationPassword,
      ConfirmPassword: this.confirmRegistrationPassword,
      FirstName: this.firstName,
      LastName: this.lastName,
      RandomCode: this.randomCode,
    })
      .pipe(finalize(() => {
        loader.dismiss();
      }))
      .subscribe(result => {

        ////////////////////////////////////////////
        // this only happens if there's a member card added during registration
        if(this.memberCard != null) {
          this.account.addExistingCard(this.memberCard)
            .subscribe((model) => {

            });
        }
        ////////////////////////////////////////////
        this.alertService.showTranslate('your account has been created successfully');

        this.gotologin();

        //this.onSubmit.emit();
        this.analytics.conversionUpdate("signUp");
      },
      (error: HttpErrorResponse) => {
        if (error.status == 500)
          this.alertService.showUnexpectedErrorMsg();
        else {
          const modelState = error.error.ModelState;

          if (!modelState) 
            return;

          for (let key in modelState) {
            let property = HttpHelpers.removePrefix(key, 'model.');
            property = property.charAt(0).toLowerCase() + property.slice(1);
            //this.formErrors.set(property, modelState[key][0]);
          }
        }
      });
  }


  

  // login
  async onFormSubmited() {
    const loader = await this.loader.create();
    this.authService.login({
      Email: this.email,
      Password: this.password
    })
    .pipe(finalize(async () => {
      await loader.dismiss();
    }))
    .subscribe(async () => {
      /*
      if (this.selfManage || this.fromDesktopCheckout) {
        return;
      }
      */

      this.analytics.conversionUpdate("signIn");

      if(!this.unchangeUrl) {
        var CurrentUrl;
        CurrentUrl = localStorage.getItem('Stateurl');
        if(CurrentUrl.includes('popup-')) {

          if(CurrentUrl.includes('store')) {
            const modal = await this.modalCtrl.create({
              component: StoreListModalComponent,
              cssClass: 'store-popup-model',
              componentProps: {
                isTableOrder: false,
                disableHeader: true
              }
            });
          
            modal.onWillDismiss()
              .then((result) => {
                
            });
          
            await modal.present();
          } else if(CurrentUrl.includes('reservation')) {
            const modal = await this.modalCtrl.create({
              component: ReservationComponent,
              cssClass: 'reservation-popup-model',
              componentProps: {
                disableHeader: true
              }
            });
          
            modal.onWillDismiss()
              .then((result) => {
                
            });

            if(this.isPopup) {
              await this.modalCtrl.dismiss();
            }
          
            await modal.present();

          } else if(CurrentUrl.includes('orderlist')) {
            const modal = await this.modalCtrl.create({
              component: OrderListPageComponent,
              cssClass: 'myorders-popup-model',
              componentProps: {
                disableHeader: true
              }
            });
          
            modal.onWillDismiss()
              .then((result) => {
                
            });

            if(this.isPopup) {
              await this.modalCtrl.dismiss();
            }
          
            await modal.present();
          } else if(CurrentUrl.includes('offers')) {
            const modal = await this.modalCtrl.create({
              component: OfferPageComponent,
              cssClass: 'offers-popup-model',
              componentProps: {
                disableHeader: true
              }
            });
          
            modal.onWillDismiss()
              .then((result) => {
                
            });
          
            if(this.isPopup) {
              await this.modalCtrl.dismiss();
            }
            await modal.present();
          } else if(CurrentUrl.includes('locations')) {
            const modal = await this.modalCtrl.create({
              component: LocationsPageComponent,
              cssClass: 'location-popup-model',
              componentProps: {
                disableHeader: true
              }
            });
          
            modal.onWillDismiss()
              .then((result) => {
                
            });

            if(this.isPopup) {
              await this.modalCtrl.dismiss();
            }
          
            await modal.present();
          } else if(CurrentUrl.includes('rewards')) {
            const modal = await this.modalCtrl.create({
              component: PayRewardPageComponent,
              cssClass: 'reward-popup-model',
              componentProps: {
                disableHeader: true
              }
            });
          
            modal.onWillDismiss()
              .then((result) => {
                
            });

            if(this.isPopup) {
              await this.modalCtrl.dismiss();
            }
          
            await modal.present();
          } else if(CurrentUrl.includes('profile')) {
            const modal = await this.modalCtrl.create({
              component: ProfilePageComponent,
              cssClass: 'profile-popup-model',
              componentProps: {
                disableHeader: true
              }
            });
          
            modal.onWillDismiss()
              .then((result) => {
                
            });

            if(this.isPopup) {
              await this.modalCtrl.dismiss();
            }
          
            await modal.present();
          } else if(CurrentUrl.includes('contactus')) {
            const modal = await this.modalCtrl.create({
              component: SupportHomePageComponent,
              cssClass: 'support-popup-model',
              componentProps: {
                disableHeader: true
              }
            });
          
            modal.onWillDismiss()
              .then((result) => {
                
            });

            if(this.isPopup) {
              await this.modalCtrl.dismiss();
            }
          
            await modal.present();
          }


          
        } else {
          if(this.isPopup) {
            await this.modalCtrl.dismiss();
          }
          this.router.navigateByUrl(CurrentUrl);
        }
      } else {

        this.onLoginAllinOne.emit(true);
        
        //@Output() notLoginAllinOne: EventEmitter<boolean> = new EventEmitter<boolean>();
      }
      
      
      

    }, (error) => {
      this.authService.showLoginError(error);
    });
  }

  // needs testing when live!!!
  async onChangePasswordForgotFormSubmited() {
    const loader = await this.loader.create();
    await loader.present();
    this.authService.forgotPassword({
      Id: this.emailCodePassReset.EmailCodeId,
      RandomCode: this.resetCode,
      NewPassword: this.newPassword,
      NewPasswordConfirmation: this.confirmPassword
    })
      .pipe(finalize(() => {
        loader.dismiss();
      }))
      .subscribe((result) => {
        //this.notReceivedAnyCode();

        this.gotologin(); // move back to the login tab

      }/*, (error: HttpErrorResponse) => {
        if (error.status == 500)
          this.alertService.showUnexpectedErrorMsg();
        else {
          const modelState = error.error.ModelState;

          if (!modelState) 
            return;

          for (let key in modelState) {
            let property = HttpHelpers.removePrefix(key, 'model.');
            property = property.charAt(0).toLowerCase() + property.slice(1);
            this.formErrors.set(property, modelState[key][0]);
            console.log(this.formErrors);
          }
        }
      }*/);
  }

  async onResetCodeFormSubmit() {
    const loader = await this.loader.create();
    await loader.present();
    this.authService.emailCodeVerificationStart(this.emailReset, "ForgotPassword", this.translationService.getLanguage())
      .pipe(finalize(() => {
        loader.dismiss();
      }))
      .subscribe((result) => {
        this.codeSentAttempt++;

        //this.forgotPasswordForm = form;  this was to save the email only. but we already have it with "this.emailReset"
        this.emailCodePassReset = result;
        this.alertService.showTranslate('code sent to your email');
      },
      (res: HttpErrorResponse) => {
        if (res.status == 404) {
          this.alertService.showTranslate('FPW.NOT_PART_OF_LISTING_MSG');
        }
      });
  }

  notReceivedAnyCode() {
    /*
    //this.forgotPasswordForm = null;
    this.emailCode = null;
    */

    if(this.codeSentAttempt >= 4) {
      this.emailCodePassReset = null;
    } else {
      this.onResetCodeFormSubmit();
    }
    
  }

  notReceivedAnyRegistrationCode() {
    

    if(this.registrationCodeSentAttempt >= 4) {
      this.emailCodeRegistration = null;
      this.registrationStep = 'email';
    } else {
      this.onRegistrationCodeFormSubmit();
    }
  }
}
